"use client";

import React from "react";

/**
 * Container - layout wrapper.
 *
 * @param {boolean|string} fluid - true = full width, 'sm'|'md'|'lg'|'xl' = fluid until breakpoint.
 */
export function Container({
  children,
  fluid = false,
  className = "",
  ...props
}) {
  const base = "w-full mx-auto px-[15px]";

  let maxWidth = "";
  if (fluid === true) {
    maxWidth = "";
  } else if (typeof fluid === "string") {
    maxWidth = {
      sm: "sm:max-w-[540px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px]",
      md: "md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px]",
      lg: "lg:max-w-[960px] xl:max-w-[1140px]",
      xl: "xl:max-w-[1140px]",
    }[fluid] ?? "";
  } else {
    maxWidth = "sm:max-w-[540px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px]";
  }

  return (
    <div
      className={`${base} ${maxWidth} ${className}`.trim()}
      {...props}
    >
      {children}
    </div>
  );
}
